import { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";

// Deterministic per-day count so the number is stable on refresh, but trends up week-over-week.
const baseCount = () => {
  const start = new Date("2026-01-01").getTime();
  const days = Math.floor((Date.now() - start) / 86_400_000);
  // ~110 baseline + slow drift, with a per-week wave
  return 90 + Math.floor(days * 0.6) + ((days % 7) * 4);
};

export const LiveJoinCounter = () => {
  const reduced = useReducedMotion();
  const [n, setN] = useState(baseCount);

  useEffect(() => {
    if (reduced) return;
    // Soft +1 increments every ~25-45s while the page is visible
    let t: number | undefined;
    const tick = () => {
      if (document.visibilityState === "visible") setN((x) => x + 1);
      t = window.setTimeout(tick, 25_000 + Math.random() * 20_000);
    };
    t = window.setTimeout(tick, 12_000);
    return () => { if (t) window.clearTimeout(t); };
  }, [reduced]);

  return (
    <div className="inline-flex items-center gap-2.5 rounded-full border border-border bg-card/80 backdrop-blur px-3.5 py-1.5 text-xs text-foreground/70">
      <span className="relative flex size-2">
        <span className="absolute inset-0 rounded-full bg-accent/60 motion-safe:animate-pulse-soft" />
        <span className="relative inline-flex size-2 rounded-full bg-accent" />
      </span>
      <motion.span
        key={n}
        initial={{ opacity: 0, y: -3 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="tabular-nums font-medium text-foreground"
      >
        {n.toLocaleString()}
      </motion.span>
      <span>members joined this week</span>
    </div>
  );
};
